import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Form, Button, Alert } from 'react-bootstrap';
import { authAPI } from '../api/api';
import { AuthContext } from '../context/AuthContext';
import './Login.css';

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { setUser } = useContext(AuthContext);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await authAPI.login(username, password);
      if (response.data && response.data.success) {
        setUser(response.data.user);
        navigate('/dashboard');
      } else {
        setError(response.data?.message || 'Login failed');
      }
    } catch (err) {
      const errorMessage = err.response?.data?.message || err.message || 'An error occurred during login';
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container className="login-container">
      <div className="login-box">
        <div className="login-logo">
          <img src="/aaimsdm/logo-banner.png" alt="AAIMS Logo" style={{ maxWidth: '100%', height: 'auto' }} />
        </div>
        <h1>
          <span style={{ color: '#28a745' }}>A</span>I-Enhanced <span style={{ color: '#28a745' }}>A</span>nalytics & <span style={{ color: '#28a745' }}>I</span>ntegration for <span style={{ color: '#28a745' }}>M</span>odern <span style={{ color: '#28a745' }}>S</span>olutions
        </h1>
        <h2>Login</h2>
        
        {error && <Alert variant="danger">{error}</Alert>}
        
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Username</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Password</Form.Label>
            <Form.Control
              type="password"
              placeholder="Enter password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </Form.Group>

          <Button 
            variant="primary" 
            type="submit" 
            className="w-100"
            disabled={loading}
          >
            {loading ? 'Logging in...' : 'Login'}
          </Button>
        </Form>

        <div className="login-links">
          <a onClick={() => navigate('/forgot-password')} style={{ cursor: 'pointer' }}>Forgot Password?</a>
        </div>
      </div>
    </Container>
  );
}

export default Login;
